import { REMINDER_TYPES } from './constants';

export const REMINDER_FILTER_FIELDS = [
  { key: 'type', label: 'Type' },
  { key: 'status', label: 'Status' },
  { key: 'assigned', label: 'Assignee' },
  { key: 'dateRange', label: 'Date Range' },
  { key: 'sort', label: 'Sort Order' },
];

export const REMINDER_TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  ...Object.entries(REMINDER_TYPES).map(([value, meta]) => ({
    value,
    label: meta.label,
  })),
];

export const REMINDER_STATUS_FILTER_OPTIONS = [
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'paused', label: 'Paused' },
  { value: 'today', label: 'Today', preset: 'today' },
  { value: 'tomorrow', label: 'Tomorrow', preset: 'tomorrow' },
  { value: 'this_week', label: 'This Week', preset: 'this_week' },
];

/** Internal sort key → API ordering param */
export const REMINDER_SORT_OPTIONS = [
  { value: 'earliest', label: 'Earliest First', ordering: 'remind_at' },
  { value: 'latest', label: 'Latest First', ordering: '-remind_at' },
  { value: 'due_asc', label: 'Due Date Ascending', ordering: 'remind_at' },
  { value: 'due_desc', label: 'Due Date Descending', ordering: '-remind_at' },
  {
    value: 'created_asc',
    label: 'Created Date Ascending',
    ordering: 'created_at',
  },
  {
    value: 'created_desc',
    label: 'Created Date Descending',
    ordering: '-created_at',
  },
];

export const DEFAULT_SORT_KEY = 'earliest';

export const REMINDERS_FILTER_STORAGE_KEY = 'reminders-filters';
